import { apiCreateEmailIdentity } from '../../../../../../common/api/email-identity'
import { apiOuathIdentityConnections } from '../../../../../../common/api/authentication'

const createEmailIdentity = data => ({
  requestPrefix: 'FSU_EMAIL_REQUIRED:CREATE_EMAIL_IDENTITY',
  request: () => apiCreateEmailIdentity(data)
})

const closeOauthModal = () => ({
  type: 'FSU_EMAIL_REQUIRED:CLOSE_OAUTH_MODAL'
})

const sendIdentityConnectEmail = email => ({
  requestPrefix: 'FSU_EMAIL_REQUIRED:SEND_IDENTITY_SNATCH',
  request: () => apiOuathIdentityConnections({ email: email })
})

export { createEmailIdentity, closeOauthModal, sendIdentityConnectEmail }
